import PropTypes from 'prop-types';
import { svgSprite } from '../../wrappers';
import css from './FieldErrorElement.module.scss';
import classNames from 'classnames';
import { generateCompStylers } from '../../../common/utils/styles';

const FieldErrorElement = ({ children, compStyle }) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    return (
        <div style={stylers.wrapper} className={classNames(css.MT4, css.errorWrapper, classes.wrapper || '')}>
            {svgSprite('warning-circle', { className: css.errorIcon })}
            <div className={css.errorText}>{children}</div>
        </div>
    );
};

FieldErrorElement.propTypes = { compStyle: PropTypes.object };

export default FieldErrorElement;
